import template from 'string-placeholder';
import mapValues from 'lodash/mapValues';
import isString from 'lodash/isString';
import get from 'lodash/get';
import de from './de';
import en from './en';
import common from './common';
// import fr from './fr';
// import it from './it';
import websail from './websail';
import debackpack from './de-backpack';
import {getLanguage, getFallbackLanguage} from "~/stateGetter";
import merge from 'lodash/merge';
import isNil from 'lodash/isNil';
import has from 'lodash/has';
import getConfig from '~/config';

const languages = {
    de,
    en,
    'de-backpack': debackpack,
    'websail': websail
};

function translatePath(languageData, key, params) {
    let val = get(languageData, key, key);

    if(!isString(val)) { return val; }

    return template(val, params);
}


const computeTrans = () => {
    let transObj = {};
    const defaultTranslations = get(getConfig(), "translations", get(window, "wsconfig.translations", {}));

    for (let lang1Name in languages) {
        if (!languages.hasOwnProperty(lang1Name)) {
            continue;
        }

        const langData1 =languages[lang1Name];

        for (let lang2Name in languages) {
            if (!languages.hasOwnProperty(lang2Name)) {
                continue;
            }

            const langData2 = languages[lang2Name];
            const language1Data =  merge({}, common, langData1, defaultTranslations);
            const language2Data = merge({}, common, langData2, language1Data);

            transObj[lang1Name] = (key, params) => translatePath(language1Data, key, params);
            transObj[lang1Name+lang2Name] = (key, params) => translatePath(language2Data, key, params);
        }
    }

    return transObj;
};

let trans = computeTrans();

export const setTrans = () => {
    trans = computeTrans();
}

export const getTranslator = (locale, fallback) => {    
    if(has(trans, locale+fallback)) {
        return trans[locale+fallback];
    }

    if(has(trans, locale)) {
        return trans[locale];
    }

    if(has(trans, fallback)) {
        return trans[fallback];
    }

    throw new Error('locale not found!');
};

// Todo: duplicate of getTranslation?
export const stateTrans = (state, key, params) => {
    let lang = getLanguage(state),
        fallbackLang = getFallbackLanguage(state);

    let resolvedValue = trans[lang]?.(key, params);
    resolvedValue = resolvedValue === key || isNil(resolvedValue) ? trans[fallbackLang]?.(key, params) : resolvedValue;

    let translated  = resolvedValue || "";

    return translated;
};

export default trans;